import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import OurWorkForm from "./OurWorkForm";

export default function ViewOurWork({ name }) {
    return (
        <CustomCard title={name}>
            <OurWorkForm type="VIEW" />
        </CustomCard>
    );
}
